export default __webpack_public_path__ + "static/media/veneto_menu.89bfa463.pdf";